document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('new_user');
  if (!form) return;

  const termsConditions = document.getElementById('terms_conditions');
  const promotionalEmails = document.getElementById('promotional_emails');
  const termsConditionsError = document.getElementById('terms-conditions-error');
  const recaptchaError = document.getElementById('recaptcha-error');
  
  // Password validation elements
  const password = document.getElementById('password');
  const passwordConfirmation = document.getElementById('password_confirmation');
  const passwordError = document.getElementById('password-error');
  const passwordConfirmationError = document.getElementById('password-confirmation-error');
  const passwordStrength = document.getElementById('password-strength');

  // Add reCAPTCHA callback function to clear error when completed
  window.onRecaptchaSuccess = function() {
    clearRecaptchaError();
  };

  // Add reCAPTCHA callback function to show error when expired
  window.onRecaptchaExpired = function() {
    if (recaptchaError) {
      recaptchaError.textContent = 'Please complete the reCAPTCHA verification.';
    }
  };

  function clearTermsConditionsError() {
    if (termsConditionsError) {
      termsConditionsError.textContent = '';
    }
    if (termsConditions) {
      termsConditions.classList.remove('is-invalid');
    }
    
    // Also clear any flash error messages related to terms and conditions
    clearFlashMessages();
  }

  function clearRecaptchaError() {
    if (recaptchaError) recaptchaError.textContent = '';
  }

  function clearPasswordErrors() {
    if (passwordError) passwordError.textContent = '';
    if (passwordConfirmationError) passwordConfirmationError.textContent = '';
    if (password) password.classList.remove('is-invalid');
    if (passwordConfirmation) passwordConfirmation.classList.remove('is-invalid');
  }

  function clearFlashMessages() {
    // Clear any flash error messages that might contain terms and conditions errors
    const flashMessages = document.querySelectorAll('.alert-danger');
    flashMessages.forEach(flash => {
      const flashText = flash.textContent || '';
      if (flashText.includes('Terms & Conditions') || flashText.includes('Privacy Policy')) {
        flash.remove();
      }
    });
  }

  function hasSpecialCharacter(str) {
    const specialChars = '!@#$%^&*()_+-=[]{}|;:,.<>?/~`"\'';
    for (let i = 0; i < str.length; i++) {
      if (specialChars.includes(str[i])) {
        return true;
      }
    }
    return false;
  }

  function validatePassword(password) {
    const minLength = password.length >= 8;
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumbers = /\d/.test(password);
    const hasSpecialChar = hasSpecialCharacter(password);
    return minLength && hasUpperCase && hasLowerCase && hasNumbers && hasSpecialChar;
  }

  function updatePasswordStrength(passwordVal) {
    if (!passwordStrength) return;

    const requirements = [
      { met: passwordVal.length >= 8, text: 'At least 8 characters' },
      { met: /[A-Z]/.test(passwordVal), text: 'Uppercase letter' },
      { met: /[a-z]/.test(passwordVal), text: 'Lowercase letter' },
      { met: /\d/.test(passwordVal), text: 'Number' },
      { met: hasSpecialCharacter(passwordVal), text: 'Special character' }
    ];

    const html = requirements.map(req =>
      `<div class="${req.met ? 'text-success' : 'text-danger'}">
        <i class="fas fa-${req.met ? 'check' : 'times'}-circle"></i> ${req.text}
      </div>`
    ).join('');
    passwordStrength.innerHTML = html;
  }

  // Clear error immediately if checkbox is already checked on page load
  if (termsConditions && termsConditions.checked) {
    clearTermsConditionsError();
    clearFlashMessages();
  }

  // Also check if there's an existing error message and clear it
  if (termsConditionsError && termsConditionsError.textContent.trim() !== '') {
    clearTermsConditionsError();
  }

  // Also clear any flash messages on page load
  clearFlashMessages();

  if (termsConditions) {
    termsConditions.addEventListener('change', function() {
      if (this.checked) {
        clearTermsConditionsError();
      }
    });
  }

  // Password input event listeners
  if (password) {
    password.addEventListener('input', function() {
      updatePasswordStrength(this.value);
      passwordError.textContent = '';
      password.classList.remove('is-invalid');
    });
  }

  if (passwordConfirmation) {
    passwordConfirmation.addEventListener('input', function() {
      passwordConfirmationError.textContent = '';
      passwordConfirmation.classList.remove('is-invalid');
    });
  }

  if (form) {
    form.addEventListener('submit', function(e) {
      let errors = [];

      // Clear all previous errors
      clearTermsConditionsError();
      clearRecaptchaError();
      clearPasswordErrors();

      // Validate Terms & Conditions checkbox
      if (!termsConditions || !termsConditions.checked) {
        errors.push('You must agree to the Terms & Conditions and Privacy Policy to register.');
        if (termsConditionsError) {
          termsConditionsError.textContent = 'You must agree to the Terms & Conditions and Privacy Policy to register.';
        }
        if (termsConditions) {
          termsConditions.classList.add('is-invalid');
        }
      }

      // Validate Password
      if (password && !validatePassword(password.value)) {
        errors.push('Password must be at least 8 characters long and include uppercase, lowercase, number and special character.');
        if (passwordError) {
          passwordError.textContent = errors[errors.length - 1];
        }
        if (password) {
          password.classList.add('is-invalid');
        }
      }

      // Validate Password Confirmation
      if (password && password.value !== passwordConfirmation.value) {
        errors.push('Passwords do not match.');
        if (passwordConfirmationError) {
          passwordConfirmationError.textContent = errors[errors.length - 1];
        }
        if (passwordConfirmation) {
          passwordConfirmation.classList.add('is-invalid');
        }
      }

      // Validate reCAPTCHA
      if (typeof grecaptcha !== 'undefined') {
        const recaptchaResponse = grecaptcha.getResponse();
        if (!recaptchaResponse || recaptchaResponse.length === 0) {
          errors.push('Please complete the reCAPTCHA verification.');
          if (recaptchaError) {
            recaptchaError.textContent = 'Please complete the reCAPTCHA verification.';
          }
        }
      }

      if (errors.length > 0) {
        e.preventDefault();
        return false;
      }
    });
  }
}); 